/**
 * TanStack Query hooks for `gclid-only-attribution`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	gclidOnlyAttributionQueryKeys,
	type CreateGclidOnlyAttributionBody,
	type ListGclidOnlyAttributionResponse,
	type GclidOnlyAttributionRow,
} from "./api";

export function useGclidOnlyAttributionList(): UseQueryResult<ListGclidOnlyAttributionResponse, Error> {
	return useQuery({
		queryKey: gclidOnlyAttributionQueryKeys.list(),
		queryFn: list,
	});
}

export function useGclidOnlyAttributionCreate(): UseMutationResult<GclidOnlyAttributionRow, Error, CreateGclidOnlyAttributionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: gclidOnlyAttributionQueryKeys.all });
		},
	});
}

export function useGclidOnlyAttributionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: gclidOnlyAttributionQueryKeys.all });
		},
	});
}
